import { DeepMap, FieldValues } from 'react-hook-form'

import { UpdateAlarmInput } from '@/graphql/generated/schemas'

import { AlarmDataTypeI } from '../../types/types'

/**
 * Constructs the input object for the UpdateAlarm mutation
 * @param id - The device/alarm ID (they share the same UUID)
 * @param values - Form values from the alarm edit form
 * @returns Formatted input for UpdateAlarm mutation
 */
export const getAlarmInputs = (
  id: string,
  values: AlarmDataTypeI
): UpdateAlarmInput => {
  return {
    id,
    externalId: values.externalId,
  }
}

/**
 * Checks if any device-level fields (name, location) have been modified
 * @param dirtyFields - Object containing dirty field flags from react-hook-form
 * @returns true if device fields are dirty, false otherwise
 */
export const isDeviceFieldsDirty = (
  dirtyFields: DeepMap<FieldValues, true>
): boolean => {
  return Object.keys(dirtyFields).some(
    (key) => key === 'name' || key === 'location'
  )
}

/**
 * Checks if any alarm-specific fields (externalId) have been modified
 * @param dirtyFields - Object containing dirty field flags from react-hook-form
 * @returns true if alarm fields are dirty, false otherwise
 */
export const isAlarmFieldsDirty = (
  dirtyFields: DeepMap<FieldValues, true>
): boolean => {
  return Object.keys(dirtyFields).some((key) => key === 'externalId')
}
